<ng-container *ngIf="initialized">

    <div #mainContent class="flex justify-content-between align-items-center gap-2 py-2">

        <div class="flex align-items-center gap-2">
            @if (contentType !== ContentTypeEnum.plain_text) {
                <p-selectButton
                        [options]="editorModeOptions"
                        [ngModel]="editor"
                        (ngModelChange)="onEditorModeChange($event)"
                        optionLabel="label"
                        optionValue="value"
                        optionDisabled="disabled"
                        [allowEmpty]="false">
                </p-selectButton>
            }

        </div>

        <div class="flex align-items-center gap-2">
            <p-skeleton *ngIf="busy" width="2rem" height="2rem" borderRadius="50%"></p-skeleton>

            <span *ngIf="isDirty" class="text-orange-500 text-sm font-bold mr-2">
                <i class="fa-solid fa-circle text-xs"></i> Ungespeicherte Änderungen
            </span>

            <p-button
                    *ngIf="previewEnabled && editor === 'textArea'"
                    [icon]="showPreview ? 'fa-regular fa-eye-slash mr-0' : 'fa-regular fa-eye mr-0'"
                    [label]="showPreview ? 'Vorschau ausblenden' : 'Vorschau anzeigen'"
                    styleClass="p-button-text surface-100 border-1 border-300"
                    (click)="togglePreview()">
            </p-button>

            <p-button
                    *ngIf="selectedTestCase"
                    icon="fa-regular fa-flask-vial mr-0"
                    label="Test ausführen"
                    styleClass="p-button-text surface-100 border-1 border-300"
                    (click)="executeTest()">
            </p-button>

            <p-splitbutton
                    (onClick)="handleSave()"
                    icon="fa-light fa-floppy-disk-circle-arrow-right"
                    label="Speichern"
                    pTooltip="Vorlage speichern" tooltipPosition="bottom"
                    [model]="toolbarButtonList" class="p-button-outlined"
            />
        </div>
    </div>

    <div *ngIf="isLegacyEditorMode" class="flex align-items-center gap-2 p-2 border-round surface-100 text-600 text-sm mb-2">
        <i class="fa-regular fa-circle-info"></i>
        <span>Editor-Modus wurde automatisch erkannt. Speichern Sie, um Ihren bevorzugten Modus beizubehalten.</span>
        <p-button icon="fa-regular fa-xmark" styleClass="p-button-text p-button-plain text-600 ml-auto" (click)="isLegacyEditorMode = false" pTooltip="Schließen" tooltipPosition="top"></p-button>
    </div>

    @if (showTestPreview) {
        <!-- Test preview mode: editor + generated preview side by side -->
        <div class="flex gap-3 mt-3  h-full overflow-auto pb-6">
            <!-- Left: Editor -->
            <div class="w-6 h-full border-1 surface-border border-round overflow-hidden">
                @if (editor === 'textArea') {
                    <code-mirror-editor
                            [editorContent]="editorContent"
                            (contentChanged)="handleCodeMirrorContentChange($event)">
                    </code-mirror-editor>
                } @else {
                    <editor
                            #tinyEditor
                            id="templateEngineTinyEditor"
                            [init]="tinyMceConfig"
                            [(ngModel)]="editorContent">
                    </editor>
                }
            </div>
            <!-- Right: Test result -->
            <div class="w-6 h-full border-1 surface-border border-round flex flex-column overflow-hidden">
                <div class="flex justify-content-between align-items-center surface-50 px-3 py-2 border-bottom-1 surface-border">
                    <span class="text-sm font-medium">
                        Testergebnis @if (selectedTestCase?.dto?.name) { <span class="text-color-secondary font-normal">({{ selectedTestCase.dto.name }})</span> }
                        <p-skeleton *ngIf="testPreviewBusy" width="1.5rem" height="1.5rem" borderRadius="50%" styleClass="ml-2"></p-skeleton>
                    </span>
                    <div class="flex align-items-center gap-1">
                        <p-button [disabled]="testPreviewBusy" icon="fa-solid fa-arrows-rotate"
                                  styleClass="p-button-text p-button-sm" (click)="onGeneratePreview.emit()"
                                  pTooltip="Erneut generieren" tooltipPosition="bottom"></p-button>
                        <p-button icon="fa-regular fa-xmark"
                                  styleClass="p-button-text p-button-sm text-color-secondary"
                                  (click)="showTestPreview = false"
                                  pTooltip="Schließen" tooltipPosition="bottom"></p-button>
                    </div>
                </div>
                @if (testPreviewError) {
                    <div class="p-3">
                        <p-messages severity="error">{{ testPreviewError }}</p-messages>
                        @if (testPreviewErrorDetails) {
                            <p-messages severity="error">{{ testPreviewErrorDetails }}</p-messages>
                        }
                    </div>
                }
                @if (testPreviewHtml) {
                    <iframe
                            [srcdoc]="testPreviewHtml"
                            sandbox="allow-scripts allow-same-origin"
                            loading="lazy"
                            class="flex-1 w-full"
                            style="border:0;">
                    </iframe>
                }
                @if (testPreviewPdf) {
                    <iframe class="flex-1 w-full" [src]="testPreviewPdf" style="border:0;"></iframe>
                }
            </div>
        </div>
    } @else {
        <!-- Normal editor mode -->
        <div *ngIf="editor == 'textArea'" class="flex gap-2 h-full pb-8 mt-2">
            <div [class]="showPreview ? 'w-6' : 'w-full'" class="h-full">
                <code-mirror-editor
                        [editorContent]="editorContent"
                        (contentChanged)="handleCodeMirrorContentChange($event)">
                </code-mirror-editor>
            </div>
            <div *ngIf="showPreview" class="w-6 h-full border-1 surface-border border-round overflow-hidden">
                <iframe
                        [srcdoc]="previewHtml"
                        sandbox="allow-same-origin"
                        width="100%"
                        height="100%"
                        style="border:0;">
                </iframe>
            </div>
        </div>

        <editor
                *ngIf="editor == 'tinyMCE'"
                #tinyEditor
                id="templateEngineTinyEditor"
                [init]="tinyMceConfig"
                [(ngModel)]="editorContent">
        </editor>
    }


    <mvs-te-variable-dialog
            *ngIf="openVariableDialog"
            [variableProviderService]="variableProviderService"
            [alias]="alias"
            [attributeName]="attributeName"
            [contentProviderId]="contentProviderId"
            [openDialog]="openVariableDialog"
            (onConfirmSelectVariable)="handleVariableSelect($event)"
            (onCloseDialog)="handleCloseDialog($event)">
    </mvs-te-variable-dialog>

    <mvs-sidebar
            *ngIf="showTableConditionDialog"
            sidebarPosition="right-40%"
            [isSidebarOpen]="showTableConditionDialog"
            (check)="showTableConditionDialog = $event">

        <ng-template mvs-sidebar-directive>

            <div class="px-3">
                <te-table-info-conditions
                        [tableAttributes]="tableAttributes"
                        [attributePath]="tableAttributePath"
                        [tableName]="tableName"
                        [condition]="tableCondition"
                        [parentObjectTypeName]="tableObjectTypeName"
                        (handleTableCondition)="handleTableCondition($event)">
                </te-table-info-conditions>

            </div>
        </ng-template>

    </mvs-sidebar>

    <mvs-sidebar
            *ngIf="showHighlightConditionDialog"
            sidebarPosition="right-40%"
            [isSidebarOpen]="showHighlightConditionDialog"
            (check)="showHighlightConditionDialog = $event">

        <ng-template mvs-sidebar-directive>

            <div class="px-3">
                <te-table-info-conditions
                        [attributePath]="tableAttributePath"
                        [tableName]="tableName"
                        [condition]="inlineConditions.condition"
                        [parentObjectTypeName]="inlineConditions.info"
                        [conditionType]="'inline'"
                        (handleTableCondition)="handleInlineCondition($event)"
                >
                </te-table-info-conditions>

            </div>
        </ng-template>

    </mvs-sidebar>

    <mvs-te-if-dialog
            *ngIf="showIfDialog"
            [(visible)]="showIfDialog"
            [mode]="ifDialogMode"
            [varPath]="ifDialogVarPath"
            [label]="ifDialogLabel"
            [dataType]="ifDialogDataType"
            [enumValues]="ifDialogEnumValues"
            [preselectedOption]="ifDialogPreselectedOption"
            (onInsert)="handleIfDialogResult($event)"
            (onCancel)="showIfDialog = false">
    </mvs-te-if-dialog>

    <p-dialog header="Variable bearbeiten" [(visible)]="showFallbackDialog" [modal]="true" [style]="{width: '450px'}">
        <div class="flex flex-column gap-3">
            <div>
                <label class="font-semibold block mb-1">Pfad</label>
                <span class="text-color-secondary">{{ fallbackDialogPath }}</span>
            </div>
            <div>
                <label class="font-semibold block mb-1">Standardwert (Fallback)</label>
                <input type="text" pInputText [(ngModel)]="fallbackDialogValue" class="w-full"
                       placeholder="Wert wenn Variable leer ist" />
            </div>
        </div>
        <ng-template pTemplate="footer">
            <p-button label="Abbrechen" severity="secondary" (click)="showFallbackDialog = false"></p-button>
            <p-button label="Speichern" (click)="saveFallbackValue()"></p-button>
        </ng-template>
    </p-dialog>

    <mvs-te-table-builder-dialog
            *ngIf="showTableBuilderDialog"
            [(visible)]="showTableBuilderDialog"
            [editMode]="tableBuilderEditMode"
            [entityAlias]="tableBuilderEntityAlias"
            [entityId]="tableBuilderEntityId"
            [collectionPath]="tableBuilderCollectionPath"
            [itemAlias]="tableBuilderItemAlias"
            [collectionLabel]="tableBuilderCollectionLabel"
            [existingColumns]="tableBuilderExistingColumns"
            (onInsertTable)="handleTableBuilderResult($event)"
            (onCancel)="showTableBuilderDialog = false">
    </mvs-te-table-builder-dialog>

</ng-container>
